/**
 * @module components\ghUpload
 */
import Vue from "vue";
import Component from "vue-class-component";
import { API_BASE_URL } from "@/utils/conf";
import { Model, Prop } from "vue-property-decorator";

@Component
export default class GhUpload extends Vue {
  @Model("on-success")
  private value!: any;
  @Prop({ default: "" })
  private id!: string;
  @Prop({ default: "picture" })
  private listType!: string;
  @Prop({ default: false })
  private isList!: boolean;

  private url = API_BASE_URL + "api/upload/files";
  private fileList: any = [];

  private onSuccess(res, file, fileList) {
    this.$emit("on-success", res);
  }
  private get source() {
    if (this.id) {
      return this.url + "/" + this.id;
    } else {
      return this.url;
    }
  }

  private onRemove(file, fileList) {
    this.$emit("on-remove", file.response);
  }

  private onBeforeUpload(file) {
    this.$emit('before-upload', file);
  }

  public clearList() {
    this.fileList = [];
  }
}
